import { render, staticRenderFns } from "./CardIce.vue?vue&type=template&id=86f8fbdc&scoped=true"
import script from "./CardIce.vue?vue&type=script&lang=js"
export * from "./CardIce.vue?vue&type=script&lang=js"
import style0 from "./CardIce.vue?vue&type=style&index=0&id=86f8fbdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86f8fbdc",
  null
  
)

export default component.exports